import { render, staticRenderFns } from "./ProjectStateButton.vue?vue&type=template&id=29dbcfc2&scoped=true"
import script from "./ProjectStateButton.vue?vue&type=script&lang=js"
export * from "./ProjectStateButton.vue?vue&type=script&lang=js"
import style0 from "./ProjectStateButton.vue?vue&type=style&index=0&id=29dbcfc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dbcfc2",
  null
  
)

export default component.exports